import { useQuery } from "@tanstack/react-query";

import { getHelpArticlesService } from "@/services/help.service";
import { HelpArticlesParams, HelpArticlesResponse } from "@/types/help.types";

export const helpQueryKeys = {
  all: () => ["help"] as const,
  articles: (params: HelpArticlesParams) => [...helpQueryKeys.all(), "articles", params] as const,
};

export const useGetHelpArticles = (params: HelpArticlesParams = {}) =>
  useQuery<HelpArticlesResponse, Error>({
    queryKey: helpQueryKeys.articles(params),
    queryFn: () => getHelpArticlesService(params),
  });
